import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { BookmarkIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
/**
 * ランキングの順位表示用のバッジ
 * @description 順位によって色が決められている（4位以下は同じ色）
 */
export const RankBadge = (props) => {
    const { className = '', rank } = props;
    /** ランキング表示の色設定 */
    const rankIconColor = useMemo(() => {
        switch (rank) {
            case 1:
                return 'secondary';
            case 2:
                return 'info';
            case 3:
                return 'primary';
            default:
                return 'none';
        }
    }, [rank]);
    return (_jsxs("div", Object.assign({ className: clsx('relative w-[24px] h-[24px]', className) }, { children: [_jsx(BookmarkIcon, { className: clsx(rankIconColor === 'none' && 'text-blue-gray-200'), color: rankIconColor, size: 'md' }), _jsx(Text, Object.assign({ className: 'absolute top-[2px] left-[9px]', color: 'white', fontFamily: 'alpha', size: 'xs', tagName: 'span' }, { children: rank }))] })));
};
